import React from 'react';

interface SectionHeaderProps {
  title: string;
  anchorId?: string | null;
}

const SectionHeader = ({ title, anchorId }: SectionHeaderProps) => {
  return (
    <header
      id={anchorId || undefined}
      className="flex scroll-mt-80 flex-col gap-8 border-0 border-b border-solid border-black pb-8"
    >
      <h2 className="m-0 font-suisse-neue text-subheadline-sm text-black">{title}</h2>
    </header>
  );
};

export default SectionHeader;
